export function getByPath(obj, path) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((o, k) => (o != null ? o[k] : undefined), obj);
}

function applyParams(s, params) {
  if (!params) return s;
  return Object.entries(params).reduce(
    (acc, [k, v]) => acc.replaceAll(`{${k}}`, String(v)),
    s,
  );
}

export function translate(dict, key, params) {
  const s = getByPath(dict, key);
  if (s === undefined || s === null) return key;
  if (typeof s !== 'string') return String(s);
  return applyParams(s, params);
}

/**
 * Tries each dictionary until a string value exists for `key` (by dot path).
 * @param {object[]} dicts
 */
export function translateWithFallback(dicts, key, params) {
  for (const dict of dicts) {
    if (!dict) continue;
    const raw = getByPath(dict, key);
    if (raw === undefined || raw === null) continue;
    if (typeof raw === 'string') return applyParams(raw, params);
    return String(raw);
  }
  return key;
}
